import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'

export default {
  __name: 'Sheet',
  props: { variant: { type: String, default: 'surface' } },
  setup(__props) {

const props = __props
const variantClass = computed(
  () =>
    ({
      surface: 'bg-catering-cream-50 border-catering-cream-400 shadow-catering-sm',
      sunken: 'bg-catering-cream-300 border-transparent',
      outline: 'bg-transparent border-catering-cream-500',
      ink: 'bg-catering-ink-900 border-transparent text-catering-cream-100 shadow-catering-md',
      lemon: 'bg-catering-lemon-300 border-transparent text-catering-ink-900'
    })[props.variant]
)

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rounded-catering-lg border p-5 transition-colors", variantClass.value])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

}